export enum RoleEnum {
  DistributorUser = "DistributorUser",
  DistributorAdmin = "DistributorAdmin",
  DistributorSuperAdmin = "DistributorSuperAdmin",
  DistributorManagement = "DistributorManagement",
  ShipcoUser = "ShipcoUser",
  ShipcoGroupUser = "ShipcoGroupUser",
  VesselUser = "VesselUser",
}
